import * as React from 'react'

import Stack from '@mui/material/Stack'
import { useFormikContext } from 'formik'
import Typography from '@mui/material/Typography'
import { TextFieldProps } from '@mui/material/TextField'

import { useData, useHandlers } from './hooks'
import { CalendarDatePicker } from '@user/components/CalendarButton'
import { IAddOpportunityFormModel } from '../../../typings'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

type Props = {
  fieldName: string
  textFieldProps?: TextFieldProps
  marginBottom?: any
  tidal?: boolean
  isMobile?: boolean
  isNextActionDateShowing: boolean
}

export function ExpectedClosingDate(props: Props) {
  const { fieldName, tidal, isMobile, isNextActionDateShowing } = props

  const { errorText, hasError } = useData({ fieldName })

  const { handleAccept } = useHandlers({ fieldName })

  const { values } = useFormikContext<IAddOpportunityFormModel>()
  const { getFormat } = useLocalizationDateFormat()

  const mobileView = isMobile && isNextActionDateShowing

  return (
    <>
      <Stack
        direction={mobileView ? 'column' : 'row'}
        justifyContent={mobileView ? 'center' : 'space-between'}
        alignItems={mobileView ? 'flex-start' : 'center'}
        gap={mobileView ? undefined : 0.5}
      >
        <Typography variant="subtitle2">Expected Closing Date *</Typography>
        <CalendarDatePicker
          value={values[fieldName]}
          onAccept={handleAccept}
          tidal={tidal}
          format={getFormat()}
          dataTestId="expected-closing-date-picker"
        />
      </Stack>
      {hasError && (
        <Typography variant="caption" color="error">
          {errorText}
        </Typography>
      )}
    </>
  )
}
